import React, { Component }        from "react";
import { Button, PageHeader, Col } from "react-bootstrap";
import Iframe                      from 'react-iframe'
import uniqueId                    from 'lodash/uniqueId';
import config                      from "../../config";
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import YouTubePlayer               from "../../components/YouTubePlayer";
import { Colors }                  from "../../utils/Colors";
import { WhiteLabel }              from "../../utils/WhiteLabelProps";

import { invokeGetYogaWorkoutDetails} from "../../utils/AwsInvoke";
//import "../../css/utils/Settings.css";


var company_id  = sessionStorage.getItem('company_id');
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

export default class Scheduler extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            programId: `${this.props.match.params.program_id}`
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getYogaPrograms();
        } catch (e) {
            alert(e);
        }
    }

    getYogaPrograms = async () => {

        var program_id  = this.state.programId; //"sTANio_2E0Q";

        var results  = await invokeGetYogaWorkoutDetails(program_id);

        if(results.status) {
            var name       = results.data[0].name;
            var start      = results.data[0].start;
            var execute    = results.data[0].execute;
            var youtube_id = results.data[0].youtube_id;

            this.setState({
                name: name,
                start: start,
                execute: execute,
                youtubeId: youtube_id,
            })
        }
    }

    createMarkup(html) { return {__html: html}; };

    renderHome() {

        var yt_id;

        //if(company_id != posture_health_company_id)

        var yt_id = this.state.youtubeId; //"sTANio_2E0Q";
        var name  = this.state.name;
        var start = this.state.start;
        var execute = this.state.execute;

        return (
              <div className="programs" style={{border: "0px solid #000"}}>
                  <br/>
                  <div>
                        { /*}<FontAwesomeIcon icon="calendar-alt" className="" style={{ position: "relative", top:7, color: Colors.primary_color, fontSize: '1.8em', paddingLeft: "18px", paddingRight:"16px" }}/>
                        <span style={{position: "relative", top:-5, fontSize:30, paddingLeft: 20}}>
                            Yoga Video Title
                        </span>*/ }
                  </div>
                  <div style={{border: "1px solid ##ccc", marginLeft:"9.5%", maxWidth: "80%"}}>
                        <YouTubePlayer yt_id={yt_id} />
                        <div style={{height: 33, width: "100%", backgroundColor: "#777"}}/>
                        <div>
                            <div style={{fontSize:22,paddingLeft: 20, paddingTop: 18}}><b>{name}</b></div>
                            <div style={{fontSize:16,paddingLeft: 20, paddingTop: 15}}>
                                { /*Time: 25 minutes<br/>
                                Equipment: Yoga mat<br/>*/}
                                <b>Health Benefits:</b> <span dangerouslySetInnerHTML={this.createMarkup(start)} /><br/>
                                <br/>
                                <div dangerouslySetInnerHTML={this.createMarkup(execute)} />
                            </div>
                        </div>
                        <br/><br/>
                  </div>
              </div>
        );
    }

    render() {
        return (
              <div className="Home">
                {this.renderHome() }
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/youtubeplayer/YoutubePlayer.js